import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Modal, Button } from 'antd';
const FormItem = Form.Item;
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory'
import { addCtnCommonAttribute } from "./SgiCtnComm"
import { convertModuleByGuid } from "./SgiCompComm"
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { SgiMainComp } from './SgiMainComp'
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory'
import { SgiPanel } from '../sgiComp/SgiPanel'

class SgiQuote extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        this.state = {
            formProps: { style: { height: '100%', width: '100%' } },
            loading: false,
            panelItems: []
        };
    }

    /**
     * 根据描述创建文本框
     * @param {弹出页面guid} uid
     * @param {对象工厂} objFct
     * @param {弹出窗标题} curtitle
     */
    nest_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        this.state.panelItems = []; //再次渲染的时候清空
        //转换基础属性
        // this.AddAttribute(moduleDesc, this.state.formProps);
        //转换form公共属性
        // addCtnCommonAttribute(this, moduleDesc, this.state.formProps);
        //组装form表单下的控件信息
        if (type !== "dnd") this.fitPanelItems(moduleDesc, this.state.panelItems, objFct, type);
    }


    AddAttribute = function (moduleDesc, formProps) {
        //嵌入UID

    }


    /**
     * 根据描述组装子对象
     * @param {描述信息} moduleDesc 
     * @param {属性} formProps 
     */
    fitPanelItems = function (moduleDesc, panelItems, objFct, type) {
        var me = this;

        var uid = moduleDesc.quoteUID;
        if (!uid) {
            return;
        }
        var uijson = PrmFactory.getPrm(uid);
        if (!uijson) {
            return;
        }
        if (!objFct) {
            objFct = new ObjFactory();
            objFct.set('@currentObjFctUID', uid);
        }
        if (moduleDesc.isInRoot == 'yes') {
            panelItems.push(convertModuleByGuid(this, uijson.cldSet[0], null, objFct, type));
        } else {
            uijson.cldSet[0].cldSet.forEach(element => {
                panelItems.push(convertModuleByGuid(this, element, null, objFct, type));
            });
        }
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    //渲染并返回一个虚拟DOM
    render = function () {
        var { objFct } = this.props;

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.nest_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        return (
            <div {...this.state.formProps}>
                {this.state.panelItems}
            </div>
        );
    }
}

export { SgiQuote };
export default SgiQuote;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiQuote.js